/* eslint-disable no-useless-concat */

//set welcome page status
export const setWelcomePage = (value) => {
  return async (dispatch) => {
    dispatch({
      type: "SET_WELCOMEPAGE",
      payload: value,
    });
  };
};
export const setFirstAttr = (value, obj) => {
  let updateGraphDetails = obj;
  updateGraphDetails.first = value;
  return (dispatch) => {
    dispatch({ type: "SET_FIRST_ATTR", graphDetail: updateGraphDetails });
  };
};
export const setSecondAttr = (value, obj) => {
  let updateGraphDetails = obj;
  updateGraphDetails.second = value;
  return (dispatch) => {
    dispatch({ type: "SET_SECOND_ATTR", graphDetail: updateGraphDetails });
  };
};
export const setFilterObj = (value, obj) => {
  let updateGraphDetails = obj;
  updateGraphDetails.filter = value;
  return (dispatch) => {
    dispatch({ type: "SET_FILTER", graphDetail: updateGraphDetails });
  };
};
export const setSplitObj = (value, obj) => {
  let updateGraphDetails = obj;
  updateGraphDetails.split = value;
  return (dispatch) => {
    dispatch({ type: "SET_SPLIT", graphDetail: updateGraphDetails });
  };
};

export const setBaseObj = (value, obj) => {
  let updateGraphDetails = obj;
  updateGraphDetails.base = value;
  return (dispatch) => {
    dispatch({ type: "SET_BASE", graphDetail: updateGraphDetails });
  };
};

export const setAILogScale = (value, obj) => {
  let updateGraphDetails = obj;
  updateGraphDetails.aiLogScale = value;
  return (dispatch) => {
    dispatch({ type: "SET_AI_LOG_SCALE", graphDetail: updateGraphDetails });
  };
};

export const setGraphBrands = (value, obj) => {
  let updateGraphDetails = obj;
  updateGraphDetails.brands = value;
  return (dispatch) => {
    dispatch({ type: "SET_GRAPH_BRANDS", graphDetail: updateGraphDetails });
  };
};
export const setGraphDuration = (value, obj) => {
  let updateGraphDetails = obj;
  updateGraphDetails.duration = value;
  return (dispatch) => {
    dispatch({ type: "SET_GRAPH_DURATION", graphDetail: updateGraphDetails });
  };
};

export const setClearGraphDetails = () => {
  let updateGraphDetails = {
    first: null,
    second: null,
    filter: null,
    split: null,
    brands: null,
    duration: null,
    base: "mentions",
    aiLogScale: null,
  };

  return (dispatch) => {
    dispatch({
      type: "SET_CLEAR_GRAPH_DETAILS",
      graphDetail: updateGraphDetails,
    });
  };
};
export const setTicketTAT = (value, ticketTAT, widget_index) => {
  let updateticketTAT = ticketTAT ? [...ticketTAT] : [];
  if (widget_index >= 0) {
    updateticketTAT[widget_index].graphData = value;
  } else if (!value) {
    updateticketTAT = value;
  } else {
    let new_array = value?.map((el) => {
      return { ...el, graphData: null };
    });
    updateticketTAT = new_array;
  }

  return (dispatch) => {
    dispatch({ type: "SET_TICKET_TAT", payload: updateticketTAT });
  };
};

export const setTicketSimpleView = (value, ticketSimpleView, widget_index) => {
  let updateticketSimpleView = ticketSimpleView ? [...ticketSimpleView] : [];
  if (widget_index >= 0) {
    updateticketSimpleView[widget_index].graphData = value;
  } else if (!value) {
    updateticketSimpleView = value;
  } else {
    let new_array = value?.map((el) => {
      return { ...el, graphData: null };
    });
    updateticketSimpleView = new_array;
  }

  return (dispatch) => {
    dispatch({
      type: "SET_TICKET_SIMPLE_VIEW",
      payload: updateticketSimpleView,
    });
  };
};
